import qs from "qs";
import { Axios as axios } from "utils/http";
import {
  apiVersion,
  headers,
  postHeaders,
  project,
  projectSource
} from "./apiConfig";

// const project = "/web";
// const host = "https://www.easy-mock.com/mock/5c00eaa143c5e53cc255f55e";
const host1 = "http://200.200.200.230/hetapi/api/mock/59/";
const host = "";

/* --------------------产品信息------------------*/
/* --------------------批次管理------------------*/
/* --------------------溯源码管理----------------*/
// 商铺类型
export const getDictionaryForShopList = params =>
  axios.get(
    `${host}/${apiVersion}${project}/common/getDictionaryForShopList?${qs.stringify(
      params
    )}`
  );
// 单位列表
export const getDictionaryForUnitList = params =>
  axios.get(
    `${host}/${apiVersion}${project}/common/getDictionaryForUnitList?${qs.stringify(
      params
    )}`
  );

// 认证列表
export const queryIdentList = params =>
  axios.get(
    `${host}/${apiVersion}${projectSource}/queryIdentList?${qs.stringify(
      params
    )}`
  );

// 16、下载批次溯源码
export const downLoadBatchQcode = params =>
  axios.post(
    `${host}/${apiVersion}${projectSource}/downLoadBatchQcode`,
    qs.stringify(params),
    {
      headers: postHeaders
    }
  );

// 15、删除批次溯源码
export const deleteBatchQcode = params =>
  axios.get(
    `${host}/${apiVersion}${projectSource}/deleteBatchQcode?${qs.stringify(
      params
    )}`
  );

// 14、获取溯源码详情
export const getBatchQcodeInfo = params =>
  axios.get(
    `${host}/${apiVersion}${projectSource}/getBatchQcodeInfo?${qs.stringify(
      params
    )}`
  );

// 13、分页获取溯源码列表
export const getBatchQcodeList = params =>
  axios.get(
    `${host}/${apiVersion}${projectSource}/getBatchQcodeList?${qs.stringify(
      params
    )}`
  );
// 获取溯源配置详情
export const getBatchConfig = params =>
  axios.get(
    `${host}/${apiVersion}${projectSource}/getBatchConfig?${qs.stringify(
      params
    )}`
  );
// 12、新增溯源配置
export const updateBatchConfig = params =>
  axios.post(
    `${host}/${apiVersion}${projectSource}/updateBatchConfig`,
    qs.stringify(params, { allowDots: true }),
    {
      headers: postHeaders
    }
  );

// 11、新增溯源码
export const insertBatchQcode = params =>
  axios.post(
    `${host}/${apiVersion}${projectSource}/insertBatchQcode`,
    qs.stringify(params),
    {
      headers: postHeaders
    }
  );

// 10、新增批次
export const insertBatch = params =>
  axios.post(
    `${host}/${apiVersion}${projectSource}/insertBatch`,
    qs.stringify(params),
    {
      headers: postHeaders
    }
  );

// 9、修改批次信息
export const updateBatch = params =>
  axios.post(
    `${host}/${apiVersion}${projectSource}/updateBatch`,
    qs.stringify(params),
    {
      headers: postHeaders
    }
  );

// 8、删除批次信息
export const deleteBatch = params =>
  axios.get(
    `${host}/${apiVersion}${projectSource}/deleteBatch?${qs.stringify(params)}`
  );

// 7、获取批次信息详情
export const getBatchInfo = params =>
  axios.get(
    `${host}/${apiVersion}${projectSource}/getBatchInfo?${qs.stringify(params)}`
  );

// 6、分页获取批次信息列表
export const getBatchList = params =>
  axios.get(
    `${host}/${apiVersion}${projectSource}/getBatchList?${qs.stringify(params)}`
  );

// 5、新增溯源产品
export const insertProduct = params =>
  axios.post(
    `${host}/${apiVersion}${projectSource}/insertProduct`,
    qs.stringify(params),
    {
      headers: postHeaders
    },
    false
  );

// 4、修改溯源产品
export const updateProduct = params =>
  axios.post(
    `${host}/${apiVersion}${projectSource}/updateProduct`,
    qs.stringify(params),
    {
      headers: postHeaders
    },
    false
  );

// 3、删除溯源产品
export const deleteProduct = params =>
  axios.get(
    `${host}/${apiVersion}${projectSource}/deleteProduct?${qs.stringify(
      params
    )}`,
    {},
    {},
    false
  );

// 2、获取溯源产品信息详情
export const getProductInfo = params =>
  axios.get(
    `${host}/${apiVersion}${projectSource}/getProductInfo?${qs.stringify(
      params
    )}`
  );

// 1、获取溯源产品信息
export const getProductList = params =>
  axios.get(
    `${host}/${apiVersion}${projectSource}/getProductList?${qs.stringify(
      params
    )}`
  );
// 溯源码管理下载二维码
export const downloadQRcode = params =>
  axios.get(
    `${host1}/${apiVersion}${projectSource}/downloadQRcode?${qs.stringify(
      params
    )}`
  );
